import React from 'react';
import ErrorBoundary from './components/common/ErrorBoundary';
import { AppProviders } from './app/providers';
import AppShell from './app/AppShell';
import './App.css';
import './styles/style.css';
import './styles/tokens.css';
import './styles/globals.css';

function App() {
  return (
    <ErrorBoundary>
      <AppProviders>
        <AppShell />
      </AppProviders>
    </ErrorBoundary>
  );
}

export default App;
